import { render, staticRenderFns } from "./ApprovalDocument2.vue?vue&type=template&id=b7865edc&scoped=true&"
import script from "./ApprovalDocument2.vue?vue&type=script&lang=js&"
export * from "./ApprovalDocument2.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalDocument2.vue?vue&type=style&index=0&id=b7865edc&prod&lang=scss&scoped=true&"
import style1 from "./ApprovalDocument2.vue?vue&type=style&index=1&id=b7865edc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7865edc",
  null
  
)

export default component.exports